import { useStatsig } from '@atlassian/mpac-feature-flags';
import { useMemo } from 'react';

export interface AiAgentStats {
  installs: number;
  teamsUsingAI: number;
}

export const useAiAgentStats = (): AiAgentStats => {
  const { getAiAgentStatsConfiguration } = useStatsig();

  return useMemo(() => {
    const statsArray = getAiAgentStatsConfiguration();

    // Handle null, undefined, or non-array values
    if (!Array.isArray(statsArray)) {
      return {
        installs: 10_000,
        teamsUsingAI: 1300,
      };
    }

    return {
      installs: statsArray[0] ?? 10_000,
      teamsUsingAI: statsArray[1] ?? 1300,
    };
  }, [getAiAgentStatsConfiguration]);
};
